import { chakra, Flex, Text, Button } from "@chakra-ui/react";
import { fonts } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const QuizInsertContainer = chakra(Flex, {
  baseStyle: {
    width: "100%",
    pr: { base: 0, md: "1rem" },
    pl: { base: 0, md: 5, lg: 0 },
    flexDirection: { base: "column", lg: "row" },
    alignItems: "stretch"
  }
});

export const QuizInsertButton = chakra(Button, {
  baseStyle: {
    borderRadius: "2px",
    border: `1px solid black ${colours.primary.dark}`,
    color: colours.primary.dark,
    fontSize: "1rem",
    width: { base: "100%", lg: "12.125rem" },
    letterSpacing: "unset",
    fontFamily: fonts.acuminRegular,
    minH: "unset",
    p: "0.5rem 15px",
    maxH: "44px !important"
  }
});

export const QuizInsertCopy = chakra(Text, {
  baseStyle: {
    color: `${colours.primary.dark} !important`
  }
});
